import getTheme from 'config/themes/base';

const theme = getTheme();

export default {
  container: {
    width: '100%',
    marginBottom: theme.spacing(1),
  },
  label: {
    marginBottom: theme.spacing(1),
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  previewContainer: {
    width: '100%',
  },
  previewButton: {
    width: '100%',
    height: '56px',
    padding: theme.spacing(1),
    justifyContent: 'flex-start',
    textTransform: 'none',
    borderColor: theme.palette.grey[300],
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(1),
    },
  },
  errorBorder: {
    borderColor: theme.palette.error.main,
    '&:hover': {
      borderColor: theme.palette.error.main,
    },
  },
  helperText: {
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(1.75),
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
  },
  errorText: {
    color: theme.palette.error.main,
  },
  popoverContent: {
    padding: theme.spacing(2),
    maxWidth: '640px',
  },
  typeSelector: {
    marginBottom: theme.spacing(2),
  },
  toggleIcon: {
    marginRight: theme.spacing(1),
    fontSize: '1.2rem',
  },
  colorPickerContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  gradientContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  gradientDirection: {
    width: '100%',
  },
  gradientColors: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  gradientLabel: {
    fontWeight: 500,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
  },
  gradientPreview: {
    width: '100%',
  },
};
